// Logistics document report DAO — thin wrapper over the
// `logistics_document_report` RPC (Zadania logistyki → Raporty tab).
// See supabase/migrations/20260925120506_logistics_document_report.sql for
// the metric definitions (corrected_count / uploaded_count).

import type { PostgrestError } from '@supabase/supabase-js';
import type { SupabaseClient } from '../base.ts';

export interface LogisticsDocumentReportRow {
  employee_id: number;
  employee_name: string;
  /** First day of the month, YYYY-MM-DD. */
  month: string;
  corrected_count: number;
  uploaded_count: number;
}

export class LogisticsDocumentReportDao {
  constructor(private readonly sb: SupabaseClient) {}

  /** `from`/`to` are YYYY-MM-DD; the RPC truncates both to the month. */
  async report(from: string, to: string): Promise<LogisticsDocumentReportRow[]> {
    // The client is schema-untyped, so the RPC response is `any` — narrow it here
    // rather than letting `any` leak into the caller.
    const { data, error } = (await this.sb.rpc('logistics_document_report', {
      p_from: from,
      p_to: to,
    })) as { data: LogisticsDocumentReportRow[] | null; error: PostgrestError | null };
    if (error) throw error;
    return data ?? [];
  }
}
